import { create } from "zustand";
import { Content } from "./SearchContent/ContentResultList/ContentListItem/ContentListItem.types";
import { SearchContentRequestStatusEnum } from "./SearchContent/SearchContent.types";

type SearchValues = {
    contentList: Content[] | undefined;
    groupIds: number[] | undefined;
    requestStatus: SearchContentRequestStatusEnum;
    searchValue: string;
};

type ContentSearchStoreSlice = SearchValues & {
    reset: () => void;
    scrollPosition: number;
    set: (value: SearchValues) => void;
    setScrollPosition: (value: number) => void;
};

export const useContentSearchStore = create<ContentSearchStoreSlice>()(
    (set) => ({
        requestStatus: SearchContentRequestStatusEnum.LOADING,
        groupIds: undefined,
        searchValue: "",
        contentList: undefined,
        set: (value: SearchValues) => set((state) => ({ ...state, ...value })),
        reset: () =>
            set({
                requestStatus: SearchContentRequestStatusEnum.LOADING,
                groupIds: undefined,
                contentList: undefined,
                searchValue: "",
            }),
        scrollPosition: 0,
        setScrollPosition: (value: number) =>
            set(() => ({ scrollPosition: value })),
    }),
);
